<template>
  <div id="app">
    <loading :show="isLoading" :label="'Loading...'"></loading>
    <login v-if="!isLoggedIn" @loggedIn="emitter++"/>
    <div v-else class="bodydiv">
      <div class="container w-container">
        <div class="imagediv">
          <img src="static/images/scwp_neg.png" alt class="image" />
        </div>
        <div
          class="text-block"
          @click="
            () => {
              debugClicked++;
            }
          "
        >
          KLAUSELVERWALTUNG ADD-IN
        </div>
        <div class="separator"></div>
        <div v-if="debugClicked > 5" style="color: red;">
          <div>Debug:</div>
          <div v-html="errorField"></div>
        </div>
        <div data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
          <div class="tabs-menu w-tab-menu">
            <!--<a
              @click="state = 'SCAN'"
              data-w-tab="Tab 1"
              class="defaultmenutab w-inline-block w-tab-link w--current"
            >
              <div>SCAN</div>
            </a>-->
            <a
              @click="state = 'CLAUSE'"
              data-w-tab="Tab 2"
              class="defaultmenutab w-inline-block w-tab-link"
            >
              <div>KLAUSELN</div>
            </a>
            <a
              @click="state = 'CONTRACT'"
              data-w-tab="Tab 3"
              class="defaultmenutab w-inline-block w-tab-link"
            >
              <div>MUSTER</div>
            </a>
          </div>
          <div class="w-tab-content">
            <transition name="fade">
              <div
                class="w-tab-pane"
                v-if="state === 'SCAN'"
              >
                <div class="tabcontentdiv">
                  <div v-if="!showTable" class="scannbuttondiv">
                    <a
                      @click="scan"
                      href="#"
                      class="updatebutton margin w-button"
                      >DOKUMENT&nbsp;SCANNEN</a
                    >
                  </div>
                  <div v-if="showTable" class="text-block-2">
                    ERKANNTE KLAUSELN ({{ clauses.length }})
                  </div>
                  <scan-clause
                    v-for="(c, idx) in clauses"
                    :key="idx"
                    :clause="c"
                    @sharePressed="insertClause"
                    @showInfo="search"
                  />
                  <div v-if="showTable" class="scannbuttondiv">
                    <a
                      @click="scan"
                      href="#"
                      class="updatebutton margin w-button"
                      >ERNEUT&nbsp;SCANNEN</a
                    >
                  </div>
                </div>
              </div>
            </transition>
            <!-- w--tab-active -->
            <transition name="fade">
              <div
                class="w-tab-pane"
                v-if="state === 'CLAUSE'"
              >
                <clause-tab />
              </div>
            </transition>
            <transition name="fade">
              <div
                class="w-tab-pane"
                v-if="state === 'CONTRACT'"
              >
                <contract-tab />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// Import Login View
import Login from './Login'
// Import component
import Loading from 'vue-full-loading'
// Import stylesheet

import ClauseTab from './ClauseTab'
import ContractTab from './ContractTab'
import ScanClause from '@/components/ScanClause'
import wordService from '@/service/wordService'
import HTTP from '@/service/httpservice'
import draggable from 'vuedraggable'
const clauseSearcher = new HTTP('/search/content')
const documentDao = new HTTP('/document/base64')

export default {
  name: 'App',
  components: {
    ClauseTab,
    ContractTab,
    ScanClause,
    draggable,
    Loading,
    Login  
  },
  data () {
    return {
      debugClicked: 0,
      errorField: '',
      // true to show the found clause table, false show the "scan document button"
      showTable: false,
      // the found clauses
      clauses: [],
      // the document should be replaced by the new content if the refresh button is clicked
      newContent: {},
      isLoading: false,
      fullPage: true,
      state: 'CLAUSE',
      emitter: 1
    }
  },
  computed: {
    isLoggedIn () {
      this.emitter++
      const token = localStorage.getItem('token')
      return token
    }
  },
  methods: {
    insertClause (clause) {
      documentDao.get(clause.id).then(res => {
        wordService.insertAt(res.data, 'base64')
      }).catch(e => {
        console.error(e)
        wordService.insertAt(clause.richText)
      })
    },
    scan () {
      this.isLoading = true
      Word.run(context => {
        // Create a proxy object for the document body.
        const body = context.document.body
        const bodyHtml = body.getHtml()
        const bodyOOXML = body.getOoxml()

        // Queue a command to load the text in the proxy body object.
        context.load(body, 'text')
        // const text = body.text;
        // Synchronize the document state by executing the queued commands,
        // and return a promise to indicate task completion.
        // body.insertHtml("<b>lol</b>", 'Replace');
        return context.sync().then(() => {
          const text = body.text
          // console.log("Body content as text: " + text);
          console.log('Body content as html')
          console.log(bodyHtml.value)
          console.log('Body content as ooxml')
          console.log(bodyOOXML.value)
          clauseSearcher
            .post({ text, html: bodyHtml.value, ooxml: bodyOOXML.value })
            .then(res => {
              const data = res.data
              console.log('Response Data')
              console.log(data)
              this.clauses = data.clauses
              this.newContent = data.newContent
              console.log('FOUND CLAUSES: ')
              console.log(this.clauses)
              this.showTable = true
              this.isLoading = false
            })
            .catch(e => {
              this.isLoading = false
              this.errorField += '<br>ERROR: ' + e + '<br>INFO: ' + e.message
              console.log(e)
            })
        })
      })
    },
    search (clause) {
      // this.errorField += 'Clause Raw Text: ' + clause.rawText
      this.isLoading = true
      this.$nextTick(() => {
        wordService
          .search(clause)
          .then(() => {
            this.isLoading = false
          })
          .catch(e => {
            console.error(e)
            this.isLoading = false
          })
      })
    }
  },
  created () {
    window.onerror = (message, url, lineNo) => {
      this.errorField += '<br>' + message + '<br>' + url + '<br>' + lineNo
      console.log(this.errorField)
      this.isLoading = false
      return true
    }
    window.addEventListener('error', event => {
      this.errorField += '<br>' + JSON.stringify(event)
      console.log(this.errorField)
      this.isLoading = false
      return true
    })
    Vue.config.errorHandler = (err, vm, info) => {
      console.log(vm)
      this.errorField += '<br>ERROR: ' + err + '<br>INFO: ' + info
      console.log(this.errorField)
      this.isLoading = false
      return true
    }
  },
  mounted () {
    const usernameToSend = localStorage.getItem('username')
    if (usernameToSend) {
      window.analytics.identify(usernameToSend, {
        name: usernameToSend,
        email: usernameToSend
      })
    }
  }
}
</script>

<style>
#content-header {
  background: #2a8dd4;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  overflow: hidden;
}

#content-main {
  background: #fff;
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}

.padding {
  padding: 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue